export default __webpack_public_path__ + "static/fargebruk-eksempel1-acf21b63462009ca8e8f832c2836b8ea.png";